import { GETINVOICESETTING_SUCCESS, GETINVOICESETTING_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getInvoiceSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETINVOICESETTING_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETINVOICESETTING_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getInvoiceSettingReducer;
